"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNullable = void 0;
function mapNullable(value, fn, notSetValue) {
    if (notSetValue === void 0) { notSetValue = undefined; }
    return value === undefined ? notSetValue : fn(value);
}
exports.mapNullable = mapNullable;
